import styled from "styled-components";

export const FooterContainer = styled.footer`
  display: flex;
  background-color: #0e2f35;
  color: #fff;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
`;
